/* W72 step 7 — THE THEME'S DEFAULT, as a pure function (Proposal 7 rule 8: "Auto follows the system — the phone's rule;
 * a coach's OS choice wins — Dark and Light one click away").
 *
 * ⚠️ THIS REVERSES THE 2026-09-18 NIGHT'S "DARK BY DEFAULT" (docs/WEB-DESIGN-DIRECTION.md §5), on his yes to Proposal 7
 * (2026-09-25 ~00:45). A coach who never touched the control now gets their operating system's choice; one who chose
 * Dark or Light keeps it, because a stored answer is theirs and is read back unchanged.
 * ⚠️ AN UNKNOWN STORED VALUE IS "system", never the nearest guess — the rule `tabFromQuery` already states. */
export type Theme = "system" | "light" | "dark";
export const THEME_STORAGE_KEY = "ht-theme";
export const DEFAULT_THEME: Theme = "system";

export function themeFromStored(raw: string | null | undefined): Theme {
  return raw === "light" || raw === "dark" || raw === "system" ? raw : DEFAULT_THEME;
}

/* W81 (the pro web step 1) — THE STORED CHOICE IS APPLIED BEFORE THE FIRST PAINT, BY THIS, NOT BY A MOUNTED CONTROL.
 *
 * Until 2026-09-26 the only thing that stamped `data-theme` was `ThemeControl`'s effect, so the choice reached the page
 * only where a control happened to be mounted. The switch now lives ONCE, in the sidebar (Fable's ruling on W81), and the
 * sign-in page has none — so without this a coach who chose Dark would sign in on a light page. `main.tsx` calls it before
 * React renders anything.
 * ⚠️ AN UNREADABLE STORE (a private window, blocked site data — the accessor itself throws) STAMPS NOTHING, which is Auto:
 * the system's own choice, never a guess. */
export type ThemeRoot = { setAttribute(name: string, value: string): void; removeAttribute(name: string): void };

export function applyStoredTheme(read: () => string | null, root: ThemeRoot): Theme {
  let theme: Theme;
  try { theme = themeFromStored(read()); } catch { theme = DEFAULT_THEME; }
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
  return theme;
}
